import React, { Component } from 'react';
import RightPanelWrap from './RightPanelWrap';
import LeftPanelWrap from './LeftPanelWrap';
import MainBodyPortraitWrap from './MainBodyPortraitWrap';
import AiHeader from './AiHeader';
import AiFooter from './AiFooter';

function clearSelection(e) {
  if (e.target.className.includes('ai-cfg') || e.target.parentNode.className.includes('ai-cfg')) {
    return
  }
  else {
    if (window.getSelection) {
      window.getSelection().removeAllRanges();
    }
    else if (document.selection) {
      document.selection.empty();
    }
  }
}

class AiLayout extends Component {
  render() {
    let body =''
    if (this.props.orientation === 'error')  
      body = <div  className='ai-main-body'>
      </div>
    else if (this.props.orientation === 'portrait')  
      body = <div  className='ai-main-body'>
    <MainBodyPortraitWrap   className='ai-main-body-panel' size={this.props.image} optionNumber={this.props.optionNumber}
        optionSize={this.props.optionSize} orientation={this.props.orientation} imageSize={this.props.image} /> 
    </div>
    else
      body = <div  className='ai-panels'>
      <LeftPanelWrap    className='ai-leftpanel' size={this.props.image}  orientation={this.props.orientation}/> 
      <RightPanelWrap  
          imageSize={this.props.image} 
          optionNumber={this.props.optionNumber}
          optionSize={this.props.optionSize}
          orientation={this.props.orientation}/>
      </div>
        
    return (<div  className='ai-body' onClick={clearSelection}>
      <AiHeader size={this.props.header} messages={this.props.messages}/>
      {body}
      
      <AiFooter size={this.props.footer}/> 
      </div>
      );
  }
}
export default AiLayout;


// WEBPACK FOOTER //
// ./src/layout/AiLayout.js